import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const RMDQ_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.RMDQ,
  title: 'Roland-Morris Disability Questionnaire (RMDQ)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'item1',
      'item2',
      'item3',
      'item4',
      'item5',
      'item6',
      'item7',
      'item8',
      'item9',
      'item10',
      'item11',
      'item12',
      'item13',
      'item14',
      'item15',
      'item16',
      'item17',
      'item18',
      'item19',
      'item20',
      'item21',
      'item22',
      'item23',
      'item24',
    ],
  },
  sections: [
    {
      name: 'rmdq',
      label: 'Roland-Morris Disability Questionnaire',
      fields: [
        {
          key: 'item1',
          label: 'Mi fa male la schiena quando cammino.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: {
            '0': 'No',
            '1': 'Sì',
          },
        },
        {
          key: 'item2',
          label: 'Mi fa male la schiena quando sto in piedi.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item3',
          label: 'Mi fa male la schiena quando mi siedo.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item4',
          label: 'Mi fa male la schiena quando mi piego o mi chino.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item5',
          label: 'Non posso sollevare oggetti pesanti a causa del dolore.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item6',
          label: 'Il dolore mi impedisce di svolgere molte attività.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item7',
          label: 'Ho difficoltà a camminare a causa del dolore.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item8',
          label: 'Ho difficoltà a cambiare posizione.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item9',
          label: 'Il dolore mi impedisce di dormire bene.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item10',
          label: 'Ho bisogno di appoggiarmi quando cammino.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item11',
          label: 'Mi muovo più lentamente a causa del dolore.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item12',
          label: 'Mi è difficile vestirsi a causa del dolore.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item13',
          label: 'Mi è difficile lavarmi o asciugarmi.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item14',
          label: 'Ho difficoltà a salire le scale.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item15',
          label: 'Ho difficoltà a camminare per lunghe distanze.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item16',
          label: 'Ho difficoltà a stare in piedi a lungo.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item17',
          label: 'Ho difficoltà a stare seduto a lungo.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item18',
          label: 'Ho difficoltà a svolgere lavori domestici.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item19',
          label: 'Ho difficoltà a sollevare borse o sacchetti.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item20',
          label: 'Ho difficoltà a camminare all’aperto.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item21',
          label: 'Ho difficoltà a svolgere attività sociali.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item22',
          label: 'Ho difficoltà a concentrarmi a causa del dolore.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item23',
          label: 'Il dolore mi rende irritabile.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
        {
          key: 'item24',
          label: 'Il dolore limita la mia vita quotidiana.',
          type: 'number',
          min: 0,
          max: 1,
          step: 1,
          maxScore: 1,
          valueDescriptions: { '0': 'No', '1': 'Sì' },
        },
      ],
    },
  ],
  computedFields: [
    {
      key: 'totale',
      label: 'Punteggio totale',
      type: 'number',
      calculation: 'SUM(scoreConfig.scoreFields)',
      maxScore: 24,
    },
  ],
};
